/**
 * 문자 템플릿 관리 (/adm/alim/sms-template)
 * ($j.Pages.Admin.AlimSmsTemplate / body data-page-name="AlimSmsTemplate")
 *
 * 템플릿 목록(DataTables, 서버 페이징) + 추가/편집 모달. 용도·세부용도는 '목록 선택 + 직접입력' 콤보이고,
 * 본문 아래 변수 버튼은 고른 용도에 쓰는 것만 보인다. 콤보 옵션·코드→표시명은 컨트롤러가 #page-data 로 넘긴다.
 */
export default class AlimSmsTemplate {
    initialize() {
        var $table = null;
        var rowCache = {}; // num => row data (편집 모달 채울 때)

        function toast(m){
            $('#atplTm').text(m);
            $('#atplToast').addClass('show');
            setTimeout(function(){ $('#atplToast').removeClass('show'); }, 3000);
        }
        function escapeHtml(s){
            return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
        }

        /* ===== info 토글 ===== */
        $('#atplInfoBtn').on('click', function(){
            $(this).toggleClass('on');
            $('#info-tpl').toggleClass('show', $(this).hasClass('on'));
        });

        /* ===== DataTables ===== */
        function initTable(){
            $table = new DataTable('#atplTable', {
                ajax: {
                    url: '/adm/ajax/alim/sms-template/list',
                    type: 'post',
                    data: function(d){ d.keyword = $('#atplSearch').val(); },
                    dataSrc: function(json){
                        rowCache = {};
                        $.each(json.data || [], function(_, r){ rowCache[r.num] = r; });
                        $('#atplCnt').text(json.recordsTotal || 0);
                        return json.data || [];
                    },
                },
                columns: [
                    {data: 'purpose', render: renderPurposeTag},
                    {data: 'detail_purpose', render: renderDetailPurposeTag},
                    {data: 'msg_type'},
                    {data: 'from_phone', render: function(v){ return v || '—'; }},
                    {data: 'title'},
                    {data: 'body', render: function(v){ return '<div class="body-prev">' + escapeHtml(v) + '</div>'; }},
                    {data: 'updated_at', render: function(v){ return v ? String(v).slice(2, 10) : '—'; }},
                    {data: 'num', orderable: false, render: function(num){
                        return '<button type="button" class="tpc-btn btn-edit" data-num="'+num+'">편집</button> '
                             + '<button type="button" class="tpc-btn del" data-num="'+num+'">삭제</button>';
                    }},
                ],
                processing: true,
                serverSide: true,
                ordering: true,
                order: [[0, 'asc']],
                displayLength: 20,
                lengthChange: false,
                searching: false,
                language: {
                    emptyTable: '등록된 템플릿이 없습니다',
                    zeroRecords: '결과가 없습니다',
                    processing: '불러오는 중…',
                },
            });
        }
        // 용도 이름 → 고정 색상(hue) (같은 이름은 항상 같은 색, 새 이름도 자동으로 다른 색)
        // 색 자체는 sass 의 .tag--hue 가 --tag-h 로 칠한다. 이름이 없으면 null(기본 흰 태그)
        function purposeHue(v){
            var s = String(v || '');
            if(!s) return null;
            var h = 0;
            for(var i=0;i<s.length;i++) h = (h*31 + s.charCodeAt(i)) >>> 0;
            return h % 360;
        }
        function renderPurposeTag(v){
            var hue = purposeHue(v);
            return hue === null
                ? '<span class="tag">' + escapeHtml(lblPurpose(v)) + '</span>'
                : '<span class="tag tag--hue" style="--tag-h:' + hue + '">' + escapeHtml(lblPurpose(v)) + '</span>';
        }
        // 세부용도 — 색 없이 흰색 통일
        function renderDetailPurposeTag(v){
            return '<span class="tag">' + escapeHtml(lblDetail(v)) + '</span>';
        }

        /* ===== 검색 ===== */
        $('#atplSearch').on('keydown', function(e){
            if(e.key === 'Enter'){ $table.ajax.reload(); }
        });

        /* ===== 모달 ===== */
        function openModal(t){
            var isEdit = !!(t && t.num);
            $('#tmTit').text(isEdit ? '템플릿 편집' : '새 템플릿 추가');
            $('#tplNum').val(isEdit ? t.num : 0);
            cboClose();
            cboSet('tplPurpose', t ? (t.purpose || '') : '');
            rebuildDetail();  // 선택 용도 기준으로 세부용도 활성/초기화
            cboSet('tplDetailPurpose', t ? (t.detail_purpose || '') : '');
            $('#tplMsgType').val(t && t.msg_type ? t.msg_type : 'SMS');
            $('#tplNm').val(t ? (t.title || '') : '');
            $('#tplBd').val(t ? (t.body || '') : '');
            // 발송번호 select — 저장된 값이 config 목록에 없으면 옵션으로 추가해 유지
            var $fp = $('#tplFromPhone');
            $fp.find('option[data-dyn]').remove();
            var fp = t ? (t.from_phone || '') : '';
            var exists = $fp.find('option').filter(function(){ return this.value === fp; }).length > 0;
            if(fp && !exists){ $fp.append($('<option data-dyn="1">').val(fp).text(fp + ' (기존값)')); }
            $fp.val(fp);
            updateCC();
            filterVars(effPurpose());
            markUsedVars();
            $('#tplOv').addClass('show');
            setTimeout(function(){ $('#tplPurpose').focus(); }, 50);
        }
        function closeModal(){ cboClose(); $('#tplOv').removeClass('show'); }
        function updateCC(){ $('#tplCC').text($('#tplBd').val().length + '자'); }
        // 본문에 실제 박힌 변수 버튼은 초록(.used), 아니면 기본 파랑
        function markUsedVars(){
            var body = $('#tplBd').val();
            $('#tplOv .vbn').each(function(){
                var v = $(this).attr('data-var');
                $(this).toggleClass('used', !!v && body.indexOf(v) > -1);
            });
        }

        /* ===== 용도/세부용도 콤보 (드롭다운 + 직접입력) ===== */
        // 데이터 — 용도/세부용도 옵션 + 코드→표시명
        var DATA = JSON.parse(document.getElementById('page-data').textContent);
        var DETAIL_MAP   = DATA.detailPurposeMap || {};
        var PURPOSE_LBL  = DATA.purposeLabels || {};
        var DETAIL_LBL   = DATA.detailPurposeLabels || {};
        var PURPOSE_OPTS = DATA.purposeOptions || [];
        function lblPurpose(v){ v = String(v||''); return PURPOSE_LBL[v] || v || '—'; }
        function lblDetail(v){  v = String(v||''); return DETAIL_LBL[v]  || v || '—'; }

        /* ===== 콤보박스: 직접 타이핑 + 오른쪽 ▾ 버튼으로 목록 선택 =====
           표시는 한글 라벨(목록 선택 시) / 친 그대로(직접입력),
           실제값은 dataset.code(목록선택) 우선, 없으면 input.value(직접입력) */
        function cboItems(id){
            if(id === 'tplPurpose')
                return PURPOSE_OPTS.map(function(c){ return { val:c, label:lblPurpose(c) }; });
            if(id === 'tplDetailPurpose'){
                var p = effPurpose();
                return ((DETAIL_MAP && DETAIL_MAP[p]) || []).map(function(c){ return { val:c, label:lblDetail(c) }; });
            }
            return [];
        }
        function cboVal(id){ var el = document.getElementById(id); return (el.dataset.code || el.value || '').trim(); }
        function effPurpose(){ return cboVal('tplPurpose'); }
        function effDetail(){  return cboVal('tplDetailPurpose'); }

        // 코드 → 콤보 표시: 알려진 코드면 라벨+code 보관, 아니면 값 그대로(=직접입력)
        function cboSet(id, code){
            var el = document.getElementById(id);
            code = (code == null ? '' : String(code)).trim();
            var hit = cboItems(id).filter(function(it){ return it.val === code; })[0];
            if(hit){ el.value = hit.label; el.dataset.code = hit.val; }
            else   { el.value = code;      el.dataset.code = ''; }
        }
        function cboRender(id){
            var el = document.getElementById(id);
            var typed = (el.value || '').trim().toLowerCase();
            var showAll = !!el.dataset.code || typed === '';
            var items = cboItems(id).filter(function(it){
                return showAll || (it.label + ' ' + it.val).toLowerCase().indexOf(typed) > -1;
            });
            var $list = $('#'+id+'_list');
            if (!items.length) { $list.empty().removeClass('show'); return false; }  // 매칭 없으면 박스 자체 숨김
            $list.html(items.map(function(it){
                return '<div class="opt" data-val="'+escapeHtml(it.val)+'">'+escapeHtml(it.label)+'</div>';
            }).join(''));
            return true;
        }
        function cboOpen(id){ if (cboRender(id)) $('#'+id+'_list').addClass('show'); }
        function cboClose(){ $('.cbo-list').removeClass('show'); }

        // 세부용도: 용도 선택 전 비활성, 용도 바뀌면 초기화
        function rebuildDetail(){
            var p  = effPurpose();
            var el = document.getElementById('tplDetailPurpose');
            el.value = ''; el.dataset.code = '';
            el.disabled = !p;
            el.placeholder = p ? '선택 또는 직접입력' : '용도를 먼저 선택';
            $('.cbo-tg[data-cbo="tplDetailPurpose"]').prop('disabled', !p).css('opacity', p ? 1 : .4);
        }

        /* 용도(purpose)별 변수 버튼 필터 — 해당 용도 태그가 하나도 없으면(미등록/오타) 전체 노출(안전 폴백) */
        function filterVars(purpose){
            purpose = String(purpose || '').trim();
            var $btns = $('#tplOv .vbn');
            var token = '|' + purpose + '|';
            var anyMatch = purpose !== '' && $btns.filter(function(){
                return ('|' + ($(this).attr('data-purposes') || '') + '|').indexOf(token) > -1;
            }).length > 0;
            $btns.each(function(){
                var ps = '|' + ($(this).attr('data-purposes') || '') + '|';
                $(this).toggle(!anyMatch || ps.indexOf(token) > -1);
            });
            // 보이는 버튼이 없는 카테고리 그룹(라벨 포함) 숨김.
            // :visible 은 모달/그룹이 display:none 일 때 항상 false → 한번 숨은 그룹이 복구 안 됨.
            // 그래서 버튼의 실제 display 인라인값으로 판정.
            $('#tplOv .vg').each(function(){
                var hasShown = $(this).find('.vbn').filter(function(){
                    return this.style.display !== 'none';
                }).length > 0;
                $(this).toggle(hasShown);
            });
        }

        $('#atpl-add-btn').on('click', function(){ openModal(null); });
        $('#atpl-close-btn, #atpl-cancel-btn').on('click', closeModal);
        // 바깥(어두운 배경) 클릭으로 닫기 — 단, '누른 곳'도 배경이어야 한다.
        //   본문 textarea 안에서 글자를 긁다가(mousedown) 창 밖에서 손을 떼면(mouseup) 브라우저는 두 지점의 공통 조상인
        //   이 오버레이에 click 을 쏜다 → e.target 이 오버레이라 창이 '저절로' 닫혔다(2026-10-07 상필 님, 수정 중 유실).
        //   mousedown 이 배경에서 시작한 경우에만 닫는다. (Ui.Modal 은 오버레이와 패널이 형제라 이 문제가 없다)
        var ovDown = false;
        $('#tplOv').on('mousedown', function(e){ ovDown = (e.target === e.currentTarget); });
        $('#tplOv').on('click', function(e){ if(ovDown && e.target === e.currentTarget) closeModal(); ovDown = false; });
        $(document).on('keydown', function(e){ if(e.key === 'Escape') closeModal(); });
        $('#tplBd').on('input', function(){ updateCC(); markUsedVars(); });

        /* ===== 콤보박스 이벤트 ===== */
        // ▾ 버튼: 목록 토글
        $('#tplOv').on('click', '.cbo-tg', function(e){
            e.preventDefault();
            if($(this).prop('disabled')) return;
            var id = $(this).data('cbo');
            var willOpen = !$('#'+id+'_list').hasClass('show');
            cboClose();
            if(willOpen){ cboOpen(id); document.getElementById(id).focus(); }
        });
        // 목록 항목 선택 (mousedown: input blur 보다 먼저 처리)
        $('#tplOv').on('mousedown', '.cbo-list .opt', function(e){
            e.preventDefault();
            var id = $(this).closest('.cbo-list').attr('id').replace(/_list$/, '');
            cboSet(id, $(this).attr('data-val'));
            cboClose();
            if(id === 'tplPurpose'){ rebuildDetail(); filterVars(effPurpose()); }
        });
        // 직접 타이핑: 커스텀값 + 목록 실시간 필터
        $('#tplOv').on('input', '#tplPurpose, #tplDetailPurpose', function(){
            this.dataset.code = '';
            cboOpen(this.id);   // 매칭 항목 있을 때만 열림, 없으면 자동으로 닫힘
            if(this.id === 'tplPurpose'){ rebuildDetail(); filterVars(effPurpose()); }
        });
        // (포커스만으론 목록 안 열림 — ▾ 버튼 클릭 또는 타이핑할 때만 열림)
        // 바깥 클릭 → 닫기
        $(document).on('mousedown.cbo', function(e){
            if(!$(e.target).closest('.cbo').length) cboClose();
        });

        /* ===== 변수 삽입 ===== */
        // mousedown 단계에서 default 막아 textarea 포커스 빼앗지 않게 → 커서/스크롤 점프 방지
        $('#tplOv').on('mousedown', '.vbn', function(e){ e.preventDefault(); });
        $('#tplOv').on('click', '.vbn', function(){
            var v = $(this).data('var');
            var $ta = $('#tplBd'), el = $ta[0];
            var st = el.selectionStart, en = el.selectionEnd;
            var prevScroll = el.scrollTop;
            var text = $ta.val();
            $ta.val(text.substring(0, st) + v + text.substring(en));
            el.focus();
            el.setSelectionRange(st + v.length, st + v.length);
            // setSelectionRange / focus 가 cursor 를 화면에 보이게 강제 스크롤하는 경우 차단
            el.scrollTop = prevScroll;
            updateCC();
            markUsedVars();
        });

        /* ===== 행 편집/삭제 ===== */
        $('#atplTable').on('click', '.btn-edit', function(){
            var num = parseInt($(this).data('num'));
            var t = rowCache[num];
            if(t) openModal(t);
        });
        $('#atplTable').on('click', '.del', function(){
            var num = parseInt($(this).data('num'));
            if(!confirm('이 템플릿을 삭제하시겠습니까?')) return;
            $.post('/adm/ajax/alim/sms-template/delete', { num: num }, function(res){
                if(res && res.ok){ toast('삭제 완료'); $table.ajax.reload(null, false); }
                else toast((res && res.message) || '삭제 실패');
            });
        });

        /* ===== 저장 ===== */
        // force=true 면 "등록되지 않은 변수" 가드를 무시하고 강제 저장
        function doSave(force){
            var num            = parseInt($('#tplNum').val()) || 0;
            var purpose        = effPurpose();
            var detailPurpose  = effDetail();
            var msgType        = $('#tplMsgType').val();
            var title          = $('#tplNm').val().trim();
            var body           = $('#tplBd').val().trim();
            var fromPhone      = ($('#tplFromPhone').val() || '').trim();

            if(!purpose){ toast('용도를 입력하세요'); return; }
            if(!detailPurpose){ toast('세부용도를 입력하세요'); return; }
            if(!fromPhone){ toast('발송번호를 선택하세요 (목록에서만 선택 가능)'); return; }
            if(!title){ toast('제목을 입력하세요'); return; }
            if(!body){ toast('본문을 입력하세요'); return; }

            var $btn = $('#atpl-save-btn').prop('disabled', true).text('저장 중...');
            $.post('/adm/ajax/alim/sms-template/save', {
                num: num,
                purpose: purpose,
                detail_purpose: detailPurpose,
                msg_type: msgType,
                title: title,
                body: body,
                from_phone: fromPhone,
                force: force ? 1 : 0,
            }, function(res){
                if(res && res.ok){
                    closeModal();
                    toast(num > 0 ? '템플릿 수정 완료' : '템플릿 추가 완료');
                    $table.ajax.reload(null, false);
                }else if(res && res.confirm){
                    var msg = String(res.message || '');
                    if(window.$j && $j.Ui && $j.Ui.Dialog){
                        $j.Ui.Dialog.open({
                            tone:  'warn',
                            title: '등록되지 않은 변수',
                            html:  msg.replace(/\n/g, '<br>'),
                            confirm: '이대로 등록',
                            cancel:  '취소',
                        }).then(function(ok){ if(ok) doSave(true); });
                    }else if(confirm(msg + '\n\n이대로 등록할까요?')){
                        doSave(true);
                    }
                }else{
                    toast((res && res.message) || '저장 실패');
                }
            }).fail(function(){
                toast('서버 오류가 발생했습니다');
            }).always(function(){
                $btn.prop('disabled', false).text('저장');
            });
        }
        $('#atpl-save-btn').on('click', function(){ doSave(false); });

        initTable();
    }
}
